import './ArtistModal.scss';

import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useArtistContext } from '../ArtistPageContext';

export default function TipJarModal({ show, handleClose, onSave }) {
  const { artist, setArtist } = useArtistContext();
  const [tipJarLink, setTipJarLink] = useState("");

  useEffect(() => {
    setTipJarLink(artist.tip_jar_link);
  }, [artist, show]);

  const handleSave = async () => {
    const updatedData = { tip_jar_link: tipJarLink };
    setArtist(prev => ({ ...prev, ...updatedData }));
    if (onSave) onSave(updatedData);
    handleClose();
  };

  return (
    <Modal className='__artist-modal' show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Add your Tip Jar link</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          Share your Tip Jar link here.
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Link</Form.Label>
            <Form.Control
              value={ tipJarLink }
              onChange={ (e) => setTipJarLink(e.target.value) }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleSave }>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
